var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    { staticClass: "concordance rounded" },
    [
      _vm.isParallel && _vm.data.annotatedField
        ? _c("td", { staticClass: "doc-version" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.data.href,
                  title: "Go to hit in document",
                  target: "_blank",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$tAnnotatedFieldDisplayName(_vm.data.annotatedField)
                  )
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("HitContextComponent", {
        staticClass: "text-right",
        attrs: {
          tag: "td",
          dir: _vm.dir,
          data: _vm.data.context,
          html: _vm.html,
          annotation: _vm.mainAnnotation.id,
          before: _vm.dir === "ltr",
          after: _vm.dir === "rtl",
          hoverMatchInfos: _vm.hoverMatchInfos,
        },
        on: {
          hover: function ($event) {
            return _vm.$emit("hover", $event)
          },
          unhover: function ($event) {
            return _vm.$emit("unhover", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("HitContextComponent", {
        staticClass: "text-center",
        attrs: {
          tag: "td",
          dir: _vm.dir,
          data: _vm.data.context,
          html: _vm.html,
          annotation: _vm.mainAnnotation.id,
          bold: "",
          hoverMatchInfos: _vm.hoverMatchInfos,
        },
        on: {
          hover: function ($event) {
            return _vm.$emit("hover", $event)
          },
          unhover: function ($event) {
            return _vm.$emit("unhover", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("HitContextComponent", {
        staticClass: "text-left",
        attrs: {
          tag: "td",
          dir: _vm.dir,
          data: _vm.data.context,
          html: _vm.html,
          annotation: _vm.mainAnnotation.id,
          after: _vm.dir === "ltr",
          before: _vm.dir === "rtl",
          hoverMatchInfos: _vm.hoverMatchInfos,
        },
        on: {
          hover: function ($event) {
            return _vm.$emit("hover", $event)
          },
          unhover: function ($event) {
            return _vm.$emit("unhover", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.otherAnnotations, function (a) {
        return _c("HitContextComponent", {
          key: a.id,
          attrs: {
            tag: "td",
            annotation: a.id,
            data: _vm.data.context,
            html: _vm.html,
            dir: _vm.dir,
            highlight: false,
            hoverMatchInfos: _vm.hoverMatchInfos,
            punct: false,
          },
          on: {
            hover: function ($event) {
              return _vm.$emit("hover", $event)
            },
            unhover: function ($event) {
              return _vm.$emit("unhover", $event)
            },
          },
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.data.gloss_fields, function (field) {
        return _c(
          "td",
          { key: field.fieldName, staticStyle: { overflow: "visible" } },
          [
            _c("GlossField", {
              attrs: {
                fieldName: field.fieldName,
                hit_first_word_id: _vm.data.hit_first_word_id,
                hit_last_word_id: _vm.data.hit_last_word_id,
                fieldDescription: field,
                hitId: _vm.data.hit_id,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.metadata, function (meta) {
        return _vm.data.doc
          ? _c("td", { key: meta.id }, [
              _vm._v(_vm._s(_vm.data.doc.docInfo[meta.id]?.join(", ") || "")),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }